
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class RacingRoundT3Index extends Vue {
}
